document.addEventListener('alpine:init', () => {
  Alpine.store("ajaxWorking",false);
  Alpine.store("submenuOpen", false);
  Alpine.store("mobileMenuOpen", false);
  Alpine.store("cartOpen", false);
  Alpine.store("helloBarOpen", true);
  //   ajaxWorking: false,
  //   submenuOpen: false,
  //   mobileMenuOpen: false,
  //   cartOpen: false,
  // });
});
